export const BASIC_LOT_DETAILS = "BasicLotDetails";
export const PICKUP_ADDRESS = "PickupAddress";
export const PICKUP_DETAILS = "PickupDetails";
export const PICKUP_SCHEDULE_DETAILS = "PickupScheduleDetails";
export const SIGNATURE = "Signature";
export const LANDING_PAGE = "LandingPage";
export const TITLE_DETAILS = "TitleDetails";



// WEBPACK FOOTER //
// ./src/containers/PickupForm/constants.js